import React, { useState } from "react";
import { StyleSheet, TextInput, View } from "react-native";
import Theme from "../argon-ui/Theme";
import * as faCharCodes from "../../assets/consts/faCharCodes";
import FontAwesomeIcon from "../components_v2/FontAwesomeIcon";

import Text from "../components_v2/TextFont";
import { HStack } from "native-base";
import { getIsRTL } from "../util";
const H_INPUT = 50;
const InputBase = React.forwardRef((props: any, ref: any) => {
  const {
    inputStyle,
    icon,
    iconLeft,
    label,
    info,
    errorMessage = "",
    errorMessageLeftElement,
    isInvalid = false,
    onBlur,
    showSubInput = false,
    labelStyle,
    containerStyle,
    keyboardType,
    isDisabled = false,
  } = props;
  const [isFocused, setIsFocused] = useState(false);
  return (
    <>
      {(label || info) && (
        <HStack space="1.5">
          {label && (
            <Text
              Text
              style={[
                {
                  color: Theme.COLORS.GRAY_DARK,
                  fontSize: 14,
                  paddingRight: 16,
                },
                { ...labelStyle },
              ]}
            >
              {label}
            </Text>
          )}
          {/* === information ===   */}
          {info && (
            <View style={{ position: "relative", width: 30, height: 30 }}>
              {info}
            </View>
          )}
        </HStack>
      )}
      <View
        style={[
          styles.searchSection,
          isFocused && { borderColor: Theme.COLORS.PRIMARY },
          isInvalid && { borderColor: Theme.COLORS.ERROR },
          { ...containerStyle },
        ]}
      >
        {icon && (
          <FontAwesomeIcon
            style={{
              paddingRight: getIsRTL() ? 15 : 0,
              paddingLeft: getIsRTL() ? 0 : 15,
            }}
            icon={icon}
            size={18}
            color={Theme.COLORS.MUTED}
          />
        )}
        <TextInput
          ref={ref}
          style={[
            styles.input,
            inputStyle,
            {
              textAlign: getIsRTL() ? "right" : "left",
              fontFamily: getIsRTL() ? "IRANSansWebFaNum" : "default",
            },
          ]}
          placeholderTextColor={Theme.COLORS.MUTED}
          underlineColorAndroid="transparent"
          isDisabled={isDisabled}
          {...props}
          onBlur={() => {
            setIsFocused(false);
            typeof onBlur == "function" && onBlur();
          }}
          onFocus={() => setIsFocused(true)}
        />
        {iconLeft && iconLeft}
      </View>
      {showSubInput && (
        <View
          style={{
            flexDirection: "row",
            justifyContent: "space-between",
            paddingHorizontal: 16,
            minHeight: 14,
          }}
        >
          <HStack alignItems="center" space="1">
            {errorMessage && errorMessage !== "" && (
              <FontAwesomeIcon
                style={{ paddingHorizontal: 4 }}
                icon={faCharCodes.faInfoCircle}
                size={14}
                color={Theme.COLORS.ERROR}
              />
            )}
            <Text style={{ color: Theme.COLORS.ERROR, fontSize: 10 }}>
              {errorMessage}
            </Text>
          </HStack>
          {errorMessageLeftElement && errorMessageLeftElement}
        </View>
      )}
    </>
  );
  // return (
  //   <FormControl
  //     isInvalid={isInvalid}
  //     style={[{ marginBottom: 5 }, containerStyle]}
  //   >
  //     {label && (
  //       <FormControl.Label
  //         _text={{
  //           marginBottom: "3",
  //           fontSize: "14",
  //         }}
  //       >
  //         {label || ""}
  //       </FormControl.Label>
  //     )}
  //     <Input
  //       variant="filled"
  //       size="md"
  //       bg="WHITE"
  //       borderColor={isInvalid ? "error.700" : "transparent"}
  //       _hover={{ bg: "WHITE", borderColor: "PRIMARY" }}
  //       _focus={{ bg: "WHITE", borderColor: "PRIMARY" }}
  //       focusOutlineColor="PRIMARY"
  //       textAlign="right"
  //       h={H_INPUT}
  //       InputLeftElement={
  //         icon ? (
  //           <Icon
  //           as={icon}
  //           size="16px"
  //           style={
  //             Platform.OS == "web" ? { marginRight: 15 } : { marginLeft: 15 }
  //           }
  //             color="muted.400"
  //             />
  //         ) : null
  //       }
  //       InputRightElement={
  //         iconLeft ? (
  //           <Icon
  //             as={iconLeft}
  //             size="16px"
  //             style={
  //               Platform.OS == "web" ? { marginLeft: 15 } : { marginRight: 15 }
  //             }
  //             color="muted.400"
  //           />
  //         ) : null
  //       }
  //       onChangeText={onChange}
  //       value={value}
  //       {...props}
  //       onBlur={onBlur}
  //       selectionColor="#DDD"
  //     />
  //     <Box
  //       flexDirection="row"
  //       justifyContent="space-between"
  //       alignItems="center"
  //     >
  //       <Box>
  //         <FormControl.ErrorMessage
  //           mr="3"
  //           leftIcon={<WarningOutlineIcon size="xs" />}
  //         >
  //           {errorMessage}
  //         </FormControl.ErrorMessage>
  //       </Box>
  //       {errorMessageLeftElement}
  //     </Box>
  //     {/* {errorMessage ||
  //       (errorMessageLeftElement && (
  //         <Box
  //           flexDirection="row"
  //           justifyContent="space-between"
  //           alignItems="center"
  //         >
  //           <Box>
  //             <FormControl.ErrorMessage
  //               leftIcon={<WarningOutlineIcon size="xs" />}
  //             >
  //               {errorMessage}
  //             </FormControl.ErrorMessage>
  //           </Box>
  //         </Box>
  //       ))} */}
  //   </FormControl>
  // );
});

export default InputBase;
const styles = StyleSheet.create({
  searchSection: {
    overflow: "hidden",
    // flex: 1,
    marginVertical: 8,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: Theme.COLORS.BORDER_COLOR,
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#fff",
  },
  searchIcon: {
    paddingRight: getIsRTL() ? 15 : 0,
    paddingLeft: getIsRTL() ? 0 : 15,
  },
  input: {
    paddingHorizontal: 10,
    height: H_INPUT,
    flex: 1,
    width: "100%",
    outlineWidth: 0,
    backgroundColor: "#fff",
    color: "#424242",
  },
});
